import { Box, Typography, Container } from "@mui/material";
import wallpaper from '../assets/iwata.jpg';
import wallpaper2 from '../assets/tttt.jpg';

const ResponsivePage = () => {
  return (
    <Container
  sx={{
    display: "flex", // Flexboxでレイアウト
    flexDirection: "row", // 横並びでレイアウト
    height: "100vh", // 画面全体の高さ
  }}
>
  {/* 左側のコンテンツ */}
  <Box
  sx={{
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    position: "relative", // 背景オーバーレイ用
    backgroundImage: `url(${wallpaper2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: 2,
  }}
>
  {/* オーバーレイの白い背景 */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 0.3)", // 白の透明度
      backdropFilter: "blur(5px)", // 背景のぼかし
      zIndex: 1, // コンテンツより下に配置
    }}
  />

  {/* コンテンツ */}
  <Box
    sx={{
      position: "relative", // オーバーレイの上に配置
      zIndex: 2,
      color: "white",
    }}
  >
    <Typography
      variant="h4"
      gutterBottom
      sx={{
        fontSize: "35px",
        fontWeight: "bold",
        fontFamily: "'Noto Serif JP', serif",
      }}
    >
      Message
    </Typography>
    <Typography variant="h5" gutterBottom>
      代表メッセージ
    </Typography>
  </Box>
</Box>

  {/* 右側のコンテンツ */}
  <Box
    sx={{
      flex: 2, // 右側の幅
      display: "flex",
      flexDirection: "column", // 縦方向のレイアウト
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center", // テキストの中央揃え
      padding: 4,
    }}
  >
    {/* 画像 */}
    <Box
      component="img"
      src={wallpaper} // 画像パスを設定
      alt="説明画像"
      sx={{
        width: { xs: "80%", sm: "60%", md: "40%" },
        maxWidth: 400,
        borderRadius: 2,
        boxShadow: 3,
        marginBottom: 4, // 画像と本文の間隔

      }}
    />
    {/* テキスト */}
    <Typography
      variant="body1"
      sx={{
        lineHeight: 1.8,
        textAlign: "left",
        margin: '15px',
        fontFamily: "'Noto Serif JP', serif",
        fontSize: '17px',
        fontWeight: 'bold',
        marginLeft: '80px'
      }}
    >
      「あなたの物語（経験）を次の時代へ」
      <br />
      <br />
      人が過去に経験してきたことの価値は、色あせず無くならない。
      <br />
      私は皆さんが過去に経験された物語に魅力を感じ、それを活かしていきたいと考えております。
      <br />
      そして、新しい価値とサービスを作り上げていく。
      <br />
      是非、皆さんの貴重な経験を我が社で活かし、新しい物語を
      <br />
      作り上げていきましょう。
      <br />
      お力をお貸しください。
      <br />
      <br />
      NextEpisode　代表取締役　社長　岩田鮎
    </Typography>
  </Box>
</Container>

  );
};

export default ResponsivePage;
